import { useCallStore } from '@/stores/useCallStore'

/**
 * Timer global du compteur d'appel affiché par InCallWidget / InCallPanel.
 *
 * Module-scope volontaire : un seul interval pour l'app, peu importe d'où il
 * est démarré (entrant via useIncomingCall, sortant via useCallActions). Évite
 * les duplications quand plusieurs composants montent les mêmes hooks.
 *
 * À appeler manuellement après les transitions du store (accept, disconnect,
 * cancel, error). Ne s'abonne PAS au store automatiquement — c'est volontaire,
 * un abonnement implicite cacherait quand le timer démarre/s'arrête.
 */
let durationInterval: ReturnType<typeof setInterval> | null = null

export function startCallDurationTimer(): void {
  if (durationInterval) clearInterval(durationInterval)
  useCallStore.getState().setCallDuration(0)
  durationInterval = setInterval(() => {
    useCallStore.getState().setCallDuration((prev) => prev + 1)
  }, 1000)
}

export function stopCallDurationTimer(): void {
  if (durationInterval) {
    clearInterval(durationInterval)
    durationInterval = null
  }
  useCallStore.getState().setCallDuration(0)
}
